import PubSub from 'services/PubSub/';
import { api } from 'config';
import StorageService from 'services/StorageService'
import Log from 'services/Log'

const jaw = 'rhk52bCR08M2fbEE7mBYSashCNpf6GL0';

const assignAddress = (lat, lng) => {
    return fetch(`${api.express}/geo/getLocal?lat=${lat}&lng=${lng}`,{
        method: 'GET',
        headers: {
            'api-key-jaw': jaw
        }
    })
        .then(results => results.json())
        .then(data => {
            if (!data.delivery_time || (data.delivery_time === 0 && data.express_delivery)) {
                Log.captureException({
                    orderForm: StorageService.getItem('orderFormId'),
                    deliveryTime: data.delivery_time,
                    sales_channel: data.sales_channel,
                    local_name: data.local_name,
                    migrated: data.migrated
                });
                data.delivery_time = 180;
            }
            return data;
        })
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}

const getAll = (token) => {
    return fetch(`${api.userAddress}/user/express/address/`, {
        method: 'GET',
        headers: {
            'token': token,
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json'
        },
    })
        .then(results => results.json())
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}

const getCurtain = () => {
    return fetch(`${api.express}/timetables?today=true`,{
        method: 'GET',
        headers: {
            'api-key-jaw': jaw
        }
    })
        .then(results => results.json())
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}

const ExpressDeliveryService = {
    assignAddress,
    getAll,
    getCurtain
}

export default ExpressDeliveryService;
